import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'serachHighlight'
})
export class SerachHighlightPipe implements PipeTransform {

  // Transform
  transform(value: any, args?: any): any {
    if (value && args) {
      const search = new RegExp(this.escapeRegExp(args), 'i');
      return value.replace(search, '<strong>$&</strong>');
    }
    else return value;
  }

  escapeRegExp(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/search-highlight/serach-highlight.pipe.ts